<template>
  <div class="seomain">
    <div class="tab-content">
      <div class="st-list-box pan-105">
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
          <div class="st-list" v-for="(v, k) in stlist" :key="k" :index="k">
            <div class="st-list-top">
              <div class="t-tit">{{ v.order_code }}</div>
              <div class="t-status"></div>
            </div>
            <div class="st-list-main">
              <p>SKU：{{ v.products_sku }}</p>
              <p>产品名称：{{ v.products_name }}</p>
              <p>批次：{{ v.batch }}</p>
              <p v-if="type == 0">供应商：{{ v.warehouse_out_name }}</p>
              <p v-if="type == 0">采购仓库：{{ v.warehouse_in_name }}</p>
              <p v-if="type == 0">采购总数：{{ v.purchase_num }}</p>
              <p v-if="type == 1">调出仓库：{{ v.warehouse_out_name }}</p>
              <p v-if="type == 1">调入仓库：{{ v.warehouse_in_name }}</p>
              <p v-if="type == 1">调拨总数：{{ v.quantity }}</p>
              <p>厂长确认数量:：{{ v.manager_num || 0 }}</p>
              <p>主管确认数量:：{{ v.director_num || 0 }}</p>
              <p @click="getExInfo(v.id)">物流单号：{{ v.logisticsnumber }}</p>
              <p>物流公司：{{ v.purchasingtracking_name }}</p>
              <p class="red">待确认数量：{{ v.to_signing_num || 0 }}</p>
            </div>
            <div class="st-list-bottom">
              <div class="st-opt-btn" @click="doEdit(v.id, v.products_sku)">
                确认签收
              </div>
              <!-- <router-link :to="'/receive/info/'+v.id" class="st-opt-btn">确认签收</router-link> -->
            </div>
          </div>
        </van-list>
      </div>
    </div>

    <div class="footer pf-btm">
      <div class="btn" @click="onSignfor">
        批量确认
      </div>
    </div>

    <van-dialog class="exDialog" ref="exDialog" v-model="exShow" :title="exDialogTitle">
      <van-steps direction="vertical" :active="0" active-color="#fa6e09">
        <van-step v-for="(item, index) in exDataList" :key="index">
          <h3>{{ item.time }}</h3>
          <p>{{ item.step }}</p>
        </van-step>
      </van-steps>
    </van-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      exShow: false,
      allShow: false,
      stlist: [],
      code: "",
      exDataList: [], // 物流信息
      exDialogTitle: "",
      loading: false,
      finished: false,
      page: 1,
    };
  },
  watch: {},
  computed: {
    type() {
      return this.$route.params.type; // 0-采购  1-调拨
    },
  },
  methods: {
    // 批量操作对应单号下的"确认签收"
    async onSignfor() {
      let id = this.$route.params.id;
      let type = this.$route.params.type;
      try {
        let flag = await this.$dialog.confirm({ title: "批量确认", message: "确认数据无误,批量确认" });
        if (flag != "confirm") return;
        let result = await this.$post(this.$api.stSetQianshouAuth, { id, type });
        this.$toast.success("批量确认成功");
      } catch (error) {}
    },
    async onLoad() {
      let id = this.$route.params.id;
      let type = this.$route.params.type;
      let result = await this.$post(this.$api.stSetQianshouInfoList, { page: this.page, type, id });
      if (result.data.length == 0) return (this.finished = true);
      this.stlist.push(...result.data);
      // 操作完成
      this.page += 1;
      this.loading = false;
    },
    // 获取物流信息
    async getExInfo(id) {
      let loading = this.$toast.loading({ message: "加载中...", forbidClick: true });
      let type = this.$route.params.type;
      let { purchasingtracking_name, logisticsnumber } = this.stlist.filter((item) => item.id == id)[0];
      this.exDialogTitle = purchasingtracking_name + ": " + logisticsnumber;

      if (type == 1) {
        let result = await this.$post(this.$api.stGetDiaoboExInfo, { id });
        if (result.data.code == 1) {
          console.log(result.data.data);
          this.exDataList = result.data.data;
        } else {
          this.exDataList = [{ step: "暂无轨迹信息,请确认订单号是否填写正确." }];
        }
        this.exShow = true;
      } else if (type == 0) {
        let result = await this.$post(this.$api.stGetCaigouExInfo, { id });
        if (result.data.code == 1) {
          console.log(result.data.data);
          this.exDataList = result.data.data;
        } else {
          this.exDataList = [{ step: "暂无轨迹信息,请确认订单号是否填写正确." }];
        }
        this.exShow = true;
      }
      loading.clear();
    },
    doEdit(id, sku) {
      let type = this.$route.params.type;
      this.$dialog
        .confirm({
          title: "是否确认数据",
          message: `SKU:${sku}`,
        })
        .then(async () => {
          let result = await this.$post(this.$api.stSetQianshouEdit, {
            type,
            id,
          });
          this.init();
          this.$toast.success("确认成功");
        })
        .catch(() => {
          // on cancel
        });
    },
  },
  created() {},
};
</script>

<style lang="scss" scoped>
.st-list-top .t-tit {
  height: 20px;
  line-height: 20px;
  margin-top: 8px;
}
.st-list-top .t-check-btn {
  padding: 6px 10px;
  border-radius: 10px;
  color: #fff;
}
.st-list-top .off {
  background: #00baad;
}
.st-list-top .on {
  background: #51596e;
}

.seomain .tab-content {
  box-sizing: border-box;
  padding-bottom: 50px;
}
.footer {
  position: fixed;
  bottom: 0;
  height: 50px;
  box-sizing: border-box;
  padding: 5px 16px;
  width: 100%;
  height: 50px;
  border-top: 1px solid #cccccc;
  background-color: #fff;
}
.seomain .pf-btm .btn {
  box-sizing: border-box;

  text-align: center;
  line-height: 40px;
  color: #fff;
  border-radius: 16px;
  background-color: #00baad;
}
</style>
